import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';
import * as d3 from "d3";

Chart.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const Hist = ({histTitle, task_data, min, max  }) => {
 
  if (!task_data || task_data.length === 0) {
    return <div>No Graph Available.</div>
  }

  //generate a dynamic range based off the min max provided from the data
  // Generate ranges using D3 package
  const bins = d3
    .bin()
    .domain([min, max]) 
    .thresholds(10)(task_data.map((item) => item.Accuracy || 0)); 
  const ranges = bins.map((bin) => `${bin.x0} - ${bin.x1}`);
  const counts = bins.map((bin) => bin.length);

  const data = {
    labels: ranges,
    datasets: [
      {
        lineTension: 0,
        label: 'Accuracy',    
        fill: false,
        borderJoinStyle: "round",
        data: counts,
        borderWidth: 0.2,
        barPercentage: 1,
        categoryPercentage: 1,
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: "black",
        hoverBackgroundColor: 'rgba(75, 192, 192, 0.6)',
        barThickness: "flex"
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: histTitle,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Range',
        },
        barPercentage: 1,
        categoryPercentage: 1,
      },
      y: {
        title: {
          display: true,
          text: 'Worker Distribution',
        },
        beginAtZero: true,
      },
    },
  };
  const style = {
    width: '1000px', 
    height: '500px', 
  };

  return <div style={style}><Bar data={data} options={options} /></div>;
};

export default Hist